// The ONE mulberry32. src/engine.js re-exports it; src/sigil/rules.js uses it for
// the stateless AI trace roll. Kept here (not in engine.js) only to avoid an
// engine <-> rules import cycle.
export function mulberry32(a) {
  return function () {
    a |= 0; a = (a + 0x6D2B79F5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}
